import { privateClient } from "@/api/privateClient";
import { SUPER_ADMIN_ENDPOINTS } from "../../../endpoint";
import type { FaqItem } from "../types";

export const listFaqs = async (): Promise<FaqItem[]> => {
  const { data } = await privateClient.get(SUPER_ADMIN_ENDPOINTS.CMS.FAQ.LIST);
  return data.faqs ?? data;
};

export const createFaq = async (payload: Omit<FaqItem, "id">): Promise<FaqItem> => {
  const { data } = await privateClient.post(SUPER_ADMIN_ENDPOINTS.CMS.FAQ.CREATE, payload);
  return data.faq ?? data;
};

export const updateFaq = async (id: number, payload: Omit<FaqItem, "id">): Promise<FaqItem> => {
  const { data } = await privateClient.put(SUPER_ADMIN_ENDPOINTS.CMS.FAQ.UPDATE(id), payload);
  return data.faq ?? data;
};

export const deleteFaq = async (id: number): Promise<void> => {
  await privateClient.delete(SUPER_ADMIN_ENDPOINTS.CMS.FAQ.DELETE(id));
};